import React, { useState } from 'react';
import { Rss, Trash2, Loader2 } from 'lucide-react';

const SOURCE_COLORS = {
  substack: 'bg-orange-200',
  twitter: 'bg-blue-200',
  blog: 'bg-green-200',
  podcast: 'bg-purple-200',
};

function SourceItem({ source, index, onDelete }) {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await onDelete(source.id);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div
      data-testid={`source-item-${source.id}`}
      className="flex items-center justify-between p-3 border-2 border-black bg-white hover:bg-pink-50 transition-colors animate-slide-up"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <span className={`source-badge ${SOURCE_COLORS[source.source_type] || 'bg-zinc-200'}`}>
          {source.source_type}
        </span>
        <span className="text-sm font-medium truncate">{source.title}</span>
      </div>
      <button
        data-testid={`delete-source-${source.id}`}
        onClick={handleDelete}
        disabled={deleting}
        className="text-zinc-400 hover:text-red-500 transition-colors ml-2 flex-shrink-0"
      >
        {deleting ? (
          <Loader2 strokeWidth={2.5} size={16} className="animate-spin" />
        ) : (
          <Trash2 strokeWidth={2.5} size={16} />
        )}
      </button>
    </div>
  );
}

function EmptySourceList() {
  return (
    <div className="text-center py-8">
      <Rss strokeWidth={2.5} size={32} className="mx-auto text-zinc-300 mb-2" />
      <p className="text-sm text-zinc-500 font-medium">No sources yet</p>
      <p className="text-xs text-zinc-400">Add your first feed above</p>
    </div>
  );
}

export function SourceList({ sources, loading, onDeleteSource }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 strokeWidth={2.5} size={20} className="animate-spin text-pink-500" />
      </div>
    );
  }

  if (sources.length === 0) {
    return <EmptySourceList />;
  }

  return (
    <div className="space-y-2">
      {sources.map((source, i) => (
        <SourceItem key={source.id} source={source} index={i} onDelete={onDeleteSource} />
      ))}
    </div>
  );
}
